import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { DropdownMenuItem, MenuItemLabel } from '../GlobalDropdown';

export const EditReleaseMenuItem = ({
  disabled = false,
  onClick,
}: {
  disabled: boolean;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}) => {
  /*
   * TODO: Rather than passing in the onClick function which clears EditedSaleSchedulePersistence,
   * we should add it directly to the onClick here since we want that to happen everytime this
   * menu item is clicked. Importing EditedSaleSchedulePersistence in this file was causing a
   * circular dependecy issue which needs to be resolved:
   * https://linear.app/sound/issue/ENG-5547/fix-circularly-dependency-issue-when-importing
   */
  return (
    <div onClick={disabled ? () => null : onClick}>
      <DropdownMenuItem disabled={disabled}>
        <FontAwesomeIcon icon={faPen} size="lg" />
        <MenuItemLabel>Edit release</MenuItemLabel>
      </DropdownMenuItem>
    </div>
  );
};
